import * as React from "react"
import Clients from "./clients/clients"
import Reviews from "./reviews/reviews"
import "./testimonials.css"

const Testimonials = () => {
    return (
        <section id={`testimonials`}>
            <Reviews/>
            <Clients/>
        </section>
    )
}

export default Testimonials